
import { overflowContainerMixin } from '../../mixins'
import EoButton from '../EoButton/EoButton.vue'
import EoIcon from '../EoIcon/EoIcon.vue'

export default {
  name: 'EoSpotify',
  components: { EoButton, EoIcon },
  mixins: [overflowContainerMixin],
  props: {
    /**
     * URL of Spotify content
     */
    url: {
      type: String,
      default: '',
    },
    /**
     * Are cookies enabled and allowed by the user?
     */
    cookiesAllowed: {
      type: Boolean,
      default: false,
    },
    /**
     * Height (percentage of width OR pixels)
     */
    height: {
      type: String,
      default: '232px',
      validator: (value) => {
        return value.includes('px') || value.includes('%')
      },
    },
  },
  computed: {
    classes () {
      return {
        'eo-spotify': true,
        'is-allowed': this.cookiesAllowed,
      }
    },
    stylesContainer () {
      return {
        paddingBottom: this.height?.includes('px') ? '0' : this.height?.includes('%') && this.height,
        height: this.height?.includes('px') && this.height,
      }
    },
    contentReference () {
      return this.url.substr(this.url.indexOf('.com/') + 5)
    },
    src () {
      return `https://open.spotify.com/embed/${this.contentReference}`
    },
  },
}
